/* eslint-disable */

import type { Address } from "viem"
import type { Config } from "wagmi"
import { readContract } from "@wagmi/core"
import { erc20Abi } from "viem"

type GetTokenMetadataProps = {
  tokenAddress: Address
  config: Config
  chainId: number
}

type TokenMetadata = {
  address: Address
  name: string
  symbol: string
  decimals: number
}

export async function getTokenMetadata({
  tokenAddress,
  config,
  chainId,
}: GetTokenMetadataProps): Promise<TokenMetadata | null> {
  try {
    const namePromise = readContract(config, {
      address: tokenAddress,
      abi: erc20Abi,
      functionName: "name",
      chainId,
    })

    const symbolPromise = readContract(config, {
      address: tokenAddress,
      abi: erc20Abi,
      functionName: "symbol",
      chainId,
    })

    const decimalsPromise = readContract(config, {
      address: tokenAddress,
      abi: erc20Abi,
      functionName: "decimals",
      chainId,
    })

    // we could add a balance check here as well for the connected user?

    const [name, symbol, decimals] = await Promise.all([namePromise, symbolPromise, decimalsPromise])

    const result = {
      address: tokenAddress,
      name,
      symbol,
      decimals,
    } satisfies TokenMetadata

    return result
  } catch (error: any) {
    console.error("getTokenMetadata", error)
    return null
  }
}
